import React from "react";
import { Helmet } from "react-helmet";
import { Image } from "antd";
import { ImageUrl } from "../../helpers/Functions";
import "./about-us.css";

import { Col, Row, Typography, Layout, Card } from "antd";

function AboutUs() {
  return (
    <div className="about-page">
      <Helmet>
        <title>Early Education Management & Facility Consulting Services</title>
        <meta
          name="description"
          content="Expert consulting for early education, offering tailored early childhood facility services and effective program management to enhance educational environments."
        />
        <meta
          property="og:title"
          content="Early Education Management & Facility Consulting Services"
        />
        <meta
          property="og:description"
          content="Expert consulting for early education, offering tailored early childhood facility services and effective program management to enhance educational environments."
        />
      </Helmet>

      <Layout className="about-layout">
        <Row className="about-hero" justify="center">
          <Col xs={22} md={18} lg={14}>
            <div className="about-hero-panel">
              <Typography.Text className="about-hero-kicker">WrightCo Academy</Typography.Text>
              <Typography.Title className="about-hero-title fontFamily1" level={1}>
                About Us
              </Typography.Title>
              <Typography.Paragraph className="about-hero-lead fontFamily1">
                <>
                  We are consultants, and trainers.
                  <br />
                  This is an online learning community.
                </>
              </Typography.Paragraph>
            </div>
          </Col>
        </Row>

        <Row className="about-section about-section-mission" gutter={[32, 32]} justify="center">
          <Col xs={24} lg={13}>
            <Card className="about-content-card infoBox" bordered={false}>
              <Typography.Paragraph className="about-section-text fontFamily1">
                WrightCo Academy&apos;s mission is to inspire and develop organizations and their
                staff to achieve continues quality improvement goals— one person, one question,
                and one small commitment to learning at a time.
              </Typography.Paragraph>
              <Typography.Paragraph className="about-section-text fontFamily1">
                We enable a great team of subject matter experts, practitioners and facilitators
                experienced in Head Start, Early Head Start, Day Care and Family Childcare, to
                provide an interactive learning experience. Our courses explore laws and regulatory
                compliance that shape early care and education program governance and design, human
                resources, facility management and health and safety into a delightful experience
                of guided discovery.
              </Typography.Paragraph>
            </Card>
          </Col>
          <Col xs={24} lg={11}>
            <div className="about-image-frame">
              <Image
                preview={false}
                alt="WrightCo Academy — about"
                className="about-image"
                src={ImageUrl("new-4.png")}
              />
            </div>
          </Col>
        </Row>
      </Layout>
    </div>
  );
}

export default AboutUs;
